export enum Experiment {
  EnablePayModalForStores = 'specs.cashier.Enable3DS2OnCheckout',
  LogCheckoutValidationErrors = 'specs.payments.LogCheckoutValidationErrors',
  APMsInModal = 'specs.payments.APMsInModal',
  UseManualTitleFromMetadata = 'specs.payments.UseManualTitleFromMetadata',
  SuspendErrorReporting = 'specs.payments.SuspendWidgetErrorReporting',
  SinglePaymentMethodViewWithLogo = 'specs.payments.SinglePaymentMethodViewWithLogo',
  EnableSquareVerifyBuyer = 'specs.payments.EnableSquareVerifyBuyer',
  EnableServerlessForWidget = 'specs.payments.EnableServerlessForWidget',
  UseSquareSandboxScripts = 'specs.payments.UseSquareSandboxScripts',
  UseSquareTestCardNonceWith3DS = 'specs.payments.UseSquareSandboxToVerifyBuyer',
  EnableTPALibraryForEvents = 'specs.payments.EnableTPALibraryForEvents',
  EnableTPALibraryForBookings = 'specs.payments.EnableTPALibraryForBookings',
  EnableTPALibraryForStores = 'specs.payments.EnableTPALibraryForStores',
  EnableTPALibraryForRestaurants = 'specs.payments.EnableTPALibraryForRestaurants',
  EnableTPALibraryForOthers = 'specs.payments.EnableTPALibrary',
  EnableWSRLibrary = 'specs.payments.EnableWSRLibrary',
  AsteriskAfterText = 'specs.payments.AsteriskAfterText',
  EnablePixBitForArtStores = 'specs.payments.EnablePixBitForArtStores',
}
